import { NgModule } from '@angular/core';
import { BpProgressComponent, BpProgressBarComponent } from './progress';

@NgModule({
  declarations: [
    BpProgressComponent,
    BpProgressBarComponent
  ],
  exports: [
    BpProgressComponent,
    BpProgressBarComponent
  ]
})
export class BpProgressModule { }
